import React from "react";
import PropTypes from "prop-types";

import { Numeric } from "rbx";

const getStyles = value => {
  const styles = {
    backgroundColor: "LIMEGREEN",
    color: "black"
  };

  if (value <= 0) {
    styles.backgroundColor = "CRIMSON";
  } else if (value <= 30) {
    styles.backgroundColor = "ORANGERED";
  } else if (value <= 45) {
    styles.backgroundColor = "ORANGE";
  } else if (value <= 60) {
    styles.backgroundColor = "YELLOW";
    styles.color = "black";
  }
  return styles;
};

const Expiration = ({ value }) => {
  const styles = getStyles(value);

  return (
    <div className="next-cert-exp-tag">
      <Numeric style={styles}>
        <b>{value}</b>
      </Numeric>
    </div>
  );
};

Expiration.propTypes = {
  value: PropTypes.number
};
export default Expiration;
